import React, { useState } from 'react';
import { useLocation, useNavigate } from 'react-router-dom';
import GeneratedVideoInline from '../components/GeneratedVideoInline';
import LoadingAnimation from '../components/LoadingAnimation';
import { mergeLastCrearAnuncioState } from '../utils/crearAnuncioStorage';

const GeneratedVideoPage: React.FC = () => {
  const location = useLocation();
  const navigate = useNavigate();
  
  const state = location.state as { videoId?: string; companyId?: string } | null;
  const params = new URLSearchParams(location.search);
  
  const initialVideoId = state?.videoId || params.get('id') || '';
  const initialCompanyId = state?.companyId || params.get('companyId') || '';

  const [videoId] = useState<string>(initialVideoId);
  const [companyId] = useState<string>(initialCompanyId);
  const [showLoading, setShowLoading] = useState<boolean>(true);

  const handleClose = () => {
    // Clear selected products when closing video results
    mergeLastCrearAnuncioState({ selectedVariantIds: [] });
    navigate(-1);
  };

  const handleReturnToConfig = () => {
    // Clear selected products when returning to product selection
    mergeLastCrearAnuncioState({ selectedVariantIds: [] });
    navigate('/redes-sociales/crear-anuncio/seleccionar-productos');
  };

  const handleReady = () => {
    setShowLoading(false);
  };

  if (!videoId || !companyId) {
    return (
      <div className="flex flex-col items-center justify-center min-h-screen p-8">
        <p className="text-gray-600 mb-4">No se encontró información del video.</p>
        <button
          onClick={handleReturnToConfig}
          className="px-4 py-2 bg-blue-500 text-white rounded-full hover:bg-blue-600"
        >
          Volver a configurar
        </button>
      </div>
    );
  }

  return (
    <div className="min-h-screen bg-white md:bg-transparent fixed inset-0 md:relative md:inset-auto z-10 md:z-auto overflow-auto">
      {showLoading && (
        <LoadingAnimation
          message="Cargando video..."
          subMessage="Preparando tu video generado"
          durationMs={10000}
          completeNow={!showLoading}
        />
      )}
      
      <GeneratedVideoInline
        videoId={videoId}
        companyId={companyId}
        onClose={handleClose}
        onReturnToConfig={handleReturnToConfig}
        onReady={handleReady}
      />
    </div>
  );
};

export default GeneratedVideoPage;
